/**
 * Контент справки для страницы отчётов.
 * Используется в панели справки HelpPanel.
 */
export default {
  // Идентификатор страницы
  pageKey: 'reports',

  // Ключ локализации заголовка страницы
  titleKey: 'help.pages.reports.title',

  // Ключ локализации описания страницы
  overviewKey: 'help.pages.reports.overview',

  // Идентификатор связанного тура
  tourId: 'reports-page',

  // FAQ - часто задаваемые вопросы
  faq: [
    {
      id: 'generate-report',
      questionKey: 'help.pages.reports.faq.generateReport.question',
      answerKey: 'help.pages.reports.faq.generateReport.answer',
    },
    {
      id: 'report-types',
      questionKey: 'help.pages.reports.faq.reportTypes.question',
      answerKey: 'help.pages.reports.faq.reportTypes.answer',
    },
    {
      id: 'custom-report',
      questionKey: 'help.pages.reports.faq.customReport.question',
      answerKey: 'help.pages.reports.faq.customReport.answer',
    },
    {
      id: 'schedule-report',
      questionKey: 'help.pages.reports.faq.scheduleReport.question',
      answerKey: 'help.pages.reports.faq.scheduleReport.answer',
    },
    {
      id: 'save-template',
      questionKey: 'help.pages.reports.faq.saveTemplate.question',
      answerKey: 'help.pages.reports.faq.saveTemplate.answer',
    },
    {
      id: 'export-pdf',
      questionKey: 'help.pages.reports.faq.exportPdf.question',
      answerKey: 'help.pages.reports.faq.exportPdf.answer',
    },
    {
      id: 'configure-columns',
      questionKey: 'help.pages.reports.faq.configureColumns.question',
      answerKey: 'help.pages.reports.faq.configureColumns.answer',
    },
    {
      id: 'column-order',
      questionKey: 'help.pages.reports.faq.columnOrder.question',
      answerKey: 'help.pages.reports.faq.columnOrder.answer',
    },
    {
      id: 'schedules-tab',
      questionKey: 'help.pages.reports.faq.schedulesTab.question',
      answerKey: 'help.pages.reports.faq.schedulesTab.answer',
    },
  ],

  // Контекстные подсказки для элементов страницы
  tooltips: {
    reportTypes: 'help.tooltips.reports.reportTypes',
    columns: 'help.tooltips.reports.columns',
    dateRange: 'help.tooltips.reports.dateRange',
    schedules: 'help.tooltips.reports.schedules',
  },

  // Связанные туры
  relatedTours: ['onboarding', 'devices-page', 'maintenance-page'],
}
